// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".samplingDialog .el-input__inner{border-radius:.3125vw!important}.samplingDialog .el-form-item{margin-bottom:.9375vw}.samplingDialog .el-form-item .el-form-item__error{font-size:.52083vw}", ""]);
// Exports
module.exports = exports;
